export const firstLetterToUpperCase = word => word[0].toUpperCase() + word.slice(1)

export const capitalizeWord = word => word[0].toUpperCase() + word.slice(1).toLowerCase()

export const capitalize = str => str.split(' ').map(capitalizeWord).join(' ')

export const strToKebab= str => str.toLowerCase().split(' ').join('-')
